import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Input, notification } from 'antd';
import UserStore from 'stores/UserStore';
import ErrorRender from 'components/shared/ErrorRender';

interface IProps {
    setModalVisible: (value: boolean) => void;
    updateData: () => void;
}

const AddEmail: React.FC<IProps> = props => {
    const [errorMessage, setErrorMessage] = useState<any>(null);
    const [response, setResponse] = useState<any>(null);
    const [responseType, setResponseType] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>();

    const [form] = Form.useForm();

    if (UserStore.errors) {
        setErrorMessage(<ErrorRender error={UserStore.errors} />);
    }

    const handleSubmit = (values: any) => {
        setResponse(null);

        setLoading(true);

        const data = {
            email: values.email,
        };

        UserStore.addEmail(data)
            .then(() => {
                setLoading(false);
                props?.setModalVisible(false);
                setEmail(data.email);
                notification.success({ message: `A verification email has been sent to ${data.email}` });

                form.resetFields();
                props.updateData();
            })
            .catch(error => {
                setResponseType('error');
                setEmail(data.email);
                setLoading(false);
                form.resetFields();
            });
    };

    return (
        <div>
            {responseType === 'error' ? (
                <Alert type="error" showIcon={true} message={`${email} is unavailable`} />
            ) : null}
            <Form form={form} onFinish={handleSubmit}>
                <div className="d-flex flex-row w-100" style={{ columnGap: '0.5rem' }}>
                    <Form.Item
                        name="email"
                        validateTrigger={['onBlur']}
                        className="flex-grow-1 mb-0"
                        rules={[
                            { type: 'email', message: 'Enter a valid Email' },
                            {
                                required: true,
                                message: 'Email address required',
                            },
                        ]}
                    >
                        <Input placeholder="Enter email address" />
                    </Form.Item>
                    <Form.Item className="mb-0">
                        <Button loading={loading} htmlType="submit" type="primary">
                            Add Email
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </div>
    );
};

export default observer(AddEmail);
